import { createFileRoute } from "@tanstack/react-router";
import { createPublicBrowseHead } from "~/lib/ssr/public-browse-head";
import { CURRENCIES_SOCIAL_METADATA } from "~/lib/social-metadata";
import { createRwaMarketsRouteLoader } from "~/features/rwa-markets/rwa-markets-route-loader";

export const Route = createFileRoute("/_app/currencies")({
  ssr: true,
  loader: createRwaMarketsRouteLoader("currencies"),
  head: () => createPublicBrowseHead("/currencies", CURRENCIES_SOCIAL_METADATA),
});
